
export const INVOICE_ISSUE_METHOD = {
    SPECIFIED: 'SPECIFIED',
    WITH_INVOICE: 'WITH_INVOICE',
    MANUAL: 'MANUAL'
}

export const MILESTONE_AMOUNT_TYPE = {
    DOLLAR: 'dollar',
    PERCENTAGE: 'percentage'
}